import styled from 'styled-components';

export const WrapperResult = styled.div`
  display: flex;
  flex-direction: column;
  strong {
    font-size: 18px;
    margin-bottom: 20px;
  }
  .section-table {
    margin: 10px;
    width: 99%;
    height: 600px;
  }
  .not-report {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
  }
`;

export const WrapperButton = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 10px;
`;
